module.exports = __webpack_public_path__ + "img/close-black.0a02c757.svg";